var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "main"
    },
    [
      _vm.withTabs
        ? _c(
            "el-card",
            {
              staticClass: "margin card-box",
              attrs: { type: "border-card", shadow: "hover" }
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.titulo))]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 12, lg: 6, xl: 6 } },
                    [
                      _c("p", { staticClass: "label" }, [_vm._v("Período:")]),
                      _c(
                        "el-date-picker",
                        _vm._b(
                          {
                            staticClass: "full-width margin-bottom",
                            attrs: {
                              type: "daterange",
                              "unlink-panels": "unlink-panels",
                              placeholder: "Selecione",
                              "range-separator": "a",
                              format: "dd/MM/yyyy",
                              "start-placeholder": "Data Inicial",
                              "end-placeholder": "Data Final",
                              name: "prazo",
                              "picker-options": _vm.options,
                              clearable: false
                            },
                            on: { change: _vm.atualizarGraficos },
                            model: {
                              value: _vm.filtro.dateRange,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "dateRange", $$v)
                              },
                              expression: "filtro.dateRange"
                            }
                          },
                          "el-date-picker",
                          _vm.$attrs,
                          false
                        )
                      )
                    ],
                    1
                  ),
                  _vm.municipios
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12, lg: 6, xl: 6 } },
                        [
                          _c("p", { staticClass: "label" }, [
                            _vm._v("Municípios:")
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "full-width input large-select",
                              attrs: {
                                "no-match-text": "Nenhuma município encontrado",
                                placeholder: "Selecione municípios",
                                name: "municipios",
                                multiple: "multiple",
                                "collapse-tags": "collapse-tags",
                                clearable: true,
                                "value-key": "id",
                                filterable: true,
                                "reserve-keyword": true,
                                "default-first-option": true
                              },
                              on: { change: _vm.atualizarGraficos },
                              model: {
                                value: _vm.filtro.municipios,
                                callback: function($$v) {
                                  _vm.$set(_vm.filtro, "municipios", $$v)
                                },
                                expression: "filtro.municipios"
                              }
                            },
                            _vm._l(_vm.municipios, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.nome, value: item }
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: _vm.atualizarSelecionarTodosMunicipios
                              },
                              model: {
                                value: _vm.selecionarTodos,
                                callback: function($$v) {
                                  _vm.selecionarTodos = $$v
                                },
                                expression: "selecionarTodos"
                              }
                            },
                            [_vm._v("Selecionar todos")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.receitas.length
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, md: 24, lg: 12, xl: 12 } },
                        [
                          _c("p", { staticClass: "label" }, [
                            _vm._v("Receitas:")
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "full-width input large-select",
                              attrs: {
                                "no-match-text": "Nenhuma receita encontrada",
                                placeholder: "Selecione uma receita",
                                name: "receita",
                                multiple: "multiple",
                                "collapse-tags": "collapse-tags",
                                clearable: true,
                                "value-key": "codigo",
                                size: "large",
                                filterable: true,
                                "reserve-keyword": true,
                                "default-first-option": true
                              },
                              on: { change: _vm.atualizarGraficos },
                              model: {
                                value: _vm.filtro.receitas,
                                callback: function($$v) {
                                  _vm.$set(_vm.filtro, "receitas", $$v)
                                },
                                expression: "filtro.receitas"
                              }
                            },
                            _vm._l(_vm.receitas, function(item) {
                              return _c("el-option", {
                                key: item.codigo,
                                attrs: { label: item.descricao, value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radioButton-container" },
                [
                  _c(
                    "el-divider",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "medium" },
                          on: { change: _vm.tabChange },
                          model: {
                            value: _vm.tipoGraficoSelecionado,
                            callback: function($$v) {
                              _vm.tipoGraficoSelecionado = $$v
                            },
                            expression: "tipoGraficoSelecionado"
                          }
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "GRAFICO" } },
                            [_vm._v("Gráfico")]
                          ),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "TABELA" } },
                            [_vm._v("Tabela")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.tipoGraficoSelecionado === "GRAFICO"
                ? _vm._t("grafico")
                : _vm._e(),
              _vm.tipoGraficoSelecionado === "TABELA"
                ? _vm._t("tabela")
                : _vm._e(),
              _vm.tipoGraficoSelecionado === "TABELA"
                ? _vm._t("pagination")
                : _vm._e(),
              _vm.valorTotal && _vm.tipoGraficoSelecionado === "GRAFICO"
                ? _c("p", { staticClass: "div-total" }, [
                    _c("b", [_vm._v("Valor total:")]),
                    _vm._v(_vm._s(" " + _vm.valorTotal))
                  ])
                : _vm._e()
            ],
            2
          )
        : _c(
            "el-card",
            {
              staticClass: "margin card-box",
              attrs: { type: "border-card", shadow: "hover" }
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.titulo))]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-date-picker",
                        _vm._b(
                          {
                            staticClass: "full-width margin-bottom",
                            attrs: {
                              type: "daterange",
                              "unlink-panels": "unlink-panels",
                              placeholder: "Selecione",
                              "range-separator": "a",
                              format: "dd/MM/yyyy",
                              "start-placeholder": "Data Inicial",
                              "end-placeholder": "Data Final",
                              name: "prazo",
                              "picker-options": _vm.options,
                              clearable: false
                            },
                            on: { change: _vm.atualizarGraficos },
                            model: {
                              value: _vm.filtro.dateRange,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "dateRange", $$v)
                              },
                              expression: "filtro.dateRange"
                            }
                          },
                          "el-date-picker",
                          _vm.$attrs,
                          false
                        )
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._t("grafico")
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-458fad52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458fad52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/relatoriosDae/components/AppRelatorioBase.vue
// module id = null
// module chunks = 